import _ from 'lodash';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { hasValue } from './hasValue';
import {
	HISTORY_EMPTY_DISPLAY_VALUE,
	isExplicitHistoryEmptyValue,
} from './historyDisplayValue';

export function useFormatHistoryValueDefault() {
	const { t } = useTranslation('common');

	return useCallback(
		(rawValue: unknown) => {
			if (isExplicitHistoryEmptyValue(rawValue)) {
				return HISTORY_EMPTY_DISPLAY_VALUE;
			}

			if (rawValue === '') {
				return null;
			}

			if (!hasValue(rawValue)) {
				return null;
			}
			const value =
				typeof rawValue === 'string' ? rawValue : JSON.stringify(rawValue);

			switch (value) {
				case 'true': {
					return t('Yes');
				}
				case 'false': {
					return t('No');
				}
				default: {
					return _.upperFirst(value);
				}
			}
		},
		[t]
	);
}
